import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'

import type { ChildrenProps, ClassNameProps } from '@root/shared/react'

export type PremiumAlertProps = {
  intent: 'success' | 'error' | 'premium'
} & ClassNameProps &
  ChildrenProps

export const PremiumAlert: React.FC<PremiumAlertProps> = ({
  className,
  children,
  intent,
}) => {
  return (
    <Root data-intent={intent} className={className}>
      {children}
    </Root>
  )
}

const Root = styled(Typography).attrs({
  variant: 'body4-bold',
  component: 'div',
})`
  padding-block: 17px;
  display: grid;

  text-align: center;
  text-overflow: ellipsis;

  &[data-intent='success'] {
    color: var(--successAccent-9);
    background: radial-gradient(
      60.94% 4173% at 47.71% -402%,
      rgba(var(--success-9-rgb), 0.05) 0%,
      var(--successA-1) 100%
    );
  }

  &[data-intent='error'] {
    color: var(--error-9);
    background: radial-gradient(
      60.94% 4173% at 47.71% -402%,
      rgba(var(--error-9-rgb), 0.05) 0%,
      var(--errorA-1) 100%
    );
  }

  &[data-intent='premium'] {
    color: var(--subscriptionButton-9);
    background: radial-gradient(
      60.94% 4173% at 47.71% -402%,
      rgba(var(--subscriptionButton-11-rgb), 0.07) 0%,
      transparent 100%
    );
  }
`
